import TicketListPage from '../../pages/tickets/TicketListPage';
import ReferredOutTicketsPage from '../../pages/tickets/ReferredOutTicketsPage';
import TicketProcessPage from '../../pages/tickets/TicketProcessPage';
import MissionDefinitionPage from '../../pages/missions/MissionDefinitionPage';
import MyMissionsPage from '../../pages/missions/MyMissionsPage';
import MissionResponsePage from '../../pages/missions/MissionResponsePage';
import { useWorkspace, PaneProvider } from '../../store/WorkspaceContext';

// react-router v6 allows only one <Router> per app, so panes can't each get
// a real isolated route the way a normal page does - resolve the tab's
// path ourselves instead, against the same small set of ticket/mission
// pages Sidebar.jsx's WORKSPACE_TAB_TITLES can open (see
// utils/workspaceConfig.js). Returns null for anything unrecognized.
function resolvePane(path) {
  if (path === '/tickets') return { Component: TicketListPage, props: {} };
  if (path === '/tickets/responded') return { Component: TicketListPage, props: { mode: 'responded' } };
  if (path === '/tickets/referred') return { Component: ReferredOutTicketsPage, props: {} };
  if (path === '/missions/define') return { Component: MissionDefinitionPage, props: {} };
  if (path === '/missions/my') return { Component: MyMissionsPage, props: {} };

  let m = path.match(/^\/tickets\/([^/]+)\/process$/);
  if (m) return { Component: TicketProcessPage, props: {}, id: m[1] };

  m = path.match(/^\/missions\/([^/]+)\/respond$/);
  if (m) return { Component: MissionResponsePage, props: {}, id: m[1] };

  return null;
}

// One tab's content. Every open tab's pane stays mounted for as long as the
// tab exists - WorkspaceGrid never unmounts a pane just because a different
// tab is focused, only when its own tab is closed - so switching tabs never
// re-fetches or resets a pane's state, and each pane's :id (via
// PaneProvider, read by usePaneContext() in TicketProcessPage/
// MissionResponsePage) is fixed to whatever ticket/mission it was opened
// for.
export default function WorkspacePane({ tabId, path }) {
  const ws = useWorkspace();
  const resolved = resolvePane(path);

  if (!resolved) {
    // Shouldn't normally happen (only workspace-eligible paths ever reach
    // here), but fail safe rather than render nothing forever.
    return (
      <div style={{ padding: 24, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>
        این بخش قابل نمایش نیست.
      </div>
    );
  }

  const { Component, props, id } = resolved;
  return (
    <PaneProvider value={{ id, close: () => ws.closeTab(tabId) }}>
      <Component {...props} />
    </PaneProvider>
  );
}
